<div id="marketplace-offer-modal" class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>

  <button (click)="modal.dismiss()" class="close" aria-describedby="modal-title" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="mb-4">
    <p>
      <fa-icon class="me-2" icon="info-circle"></fa-icon>
      <span [innerHTML]="rulesText"></span>
    </p>
  </div>

  <formly-form [fields]="fields" [form]="form"></formly-form>
</div>

<div class="modal-footer">
  <button
    [class.loading]="loadingService.loading$ | async"
    (click)="modal.dismiss()"
    class="btn btn-outline-secondary"
    type="button"
  >
    {{ "Cancel" | translate }}
  </button>

  <button
    *ngIf="!equipmentMarketplaceService.listingSold(listing)"
    [class.loading]="loadingService.loading$ | async"
    (click)="onMakeOrModifyOfferButtonClick($event)"
    class="btn btn-primary"
    type="button"
  >
    {{ makeOrModifyOfferLabel() }}
  </button>
</div>
